var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 24,
    viewBox: "0 0 132 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linet_svg__clip0_224_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.654 16.735c0 3.984 2.701 6.695 6.671 6.695h17.247v-5.226H8.464V.57H.654v16.165zM103.649.57v5.226h10.087V23.43h7.811V5.796h10.087V.57h-27.985zm-28.475 0v22.86h25.057v-5.226H82.984V14.45h16.597V9.551H82.984V5.796h17.247V.57H75.174zm-11.552 0V15.92L50.995.57h-9.34v22.86h6.347V8.08L60.628 23.43h9.34V.57h-6.346zM28.639 23.43h7.81V.57h-7.81v22.86z",
    fill: "#E10600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linet_svg__clip0_224_14"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.654 .57)",
    d: "M0 0h131v22.859H0z"
  })))));
}

export default SvgLinet;